import { createFileRoute } from "@tanstack/react-router";
import AccessibilityStatement from "@/pages/AccessibilityStatement";
export const Route = createFileRoute("/accessibility-statement")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Accessibility Statement | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Neuro Wellness TMS Centers of America is committed to digital accessibility for people with disabilities. Read our Web Content Accessibility Guidelines.",
        },
        {
          property: "og:title",
          content: "Accessibility Statement | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Neuro Wellness TMS Centers of America is committed to digital accessibility for people with disabilities. Read our Web Content Accessibility Guidelines.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/accessibility-statement",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/accessibility-statement",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AccessibilityStatement />;
}
